<template>
    <rkm-layout-body title="Lista de laboratório">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'web-service-laboratorio-cliente-laboratorio-create'})"
                authorize="store-web-service-laboratorio-cliente-laboratorio"
                color="primary"
            >
                Cadastrar laboratório
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/laboratorio/cliente/laboratorio/List'

export default {
    components: {List},
}
</script>